import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-zinc-400 text-sm" data-testid="auth-checking">
          <span className="inline-block w-2 h-2 bg-zinc-500 animate-pulse mr-2 rounded-full" />
          authenticating…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
